module.exports = "/_next/static/images/deliveryFone-93291b602d82b12fbf0288e1f02877ed.png";